export function buildAuthUserWorkspacesEntriesQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesEntriesQueryV1, TCh.Domain.Organizations',
	}
}

export function buildAuthUserWorkspacesQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.AuthUserWorkspacesQueryV1, TCh.Domain.Organizations',
	}
}

export function buildWorkspaceDetailsQueryV1(workspaceId: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceDetailsQueryV1, TCh.Domain.Organizations',
		'WorkspaceId': workspaceId,
	}
}

export function buildWorkspaceInvitationQueryV1(token: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceInvitationQueryV1, TCh.Domain.Organizations',
		'Token': token,
	}
}

export function buildWorkspaceMembersQueryV1(workspaceId: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.WorkspaceMembersQueryV1, TCh.Domain.Organizations',
		'WorkspaceId': workspaceId,
	}
}

export function buildWorkspacesByOrganizationQueryV1(tenantId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByOrganizationQueryV1, TCh.Domain.Organizations',
		'TenantId': tenantId,
	}
}

export function buildWorkspacesByUserQueryV1(userId: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.Workspaces.Queries.WorkspacesByUserQueryV1, TCh.Domain.Organizations',
		'UserId': userId,
	}
}

